(() => {
  if (window.llSizeGuideReady) return;
  window.llSizeGuideReady = true;

  const setZoom = (dialog, on) => {
    const zoom = dialog.querySelector('[data-ll-size-guide-zoom]');
    const btn = dialog.querySelector('[data-ll-size-guide-zoom-btn]');
    const hint = dialog.querySelector('[data-ll-size-guide-hint]');
    const scroll = dialog.querySelector('.ll-size-guide__scroll');
    if (!zoom) return;
    zoom.classList.toggle('is-zoomed', on);
    zoom.setAttribute('aria-pressed', on);
    if (btn) {
      btn.textContent = on ? 'Zoom out' : 'Zoom in';
      btn.setAttribute('aria-pressed', on);
    }
    if (hint) hint.textContent = on ? 'Drag to move around.' : 'Tap the chart to zoom.';
    if (scroll) {
      scroll.scrollLeft = 0;
      scroll.scrollTop = 0;
    }
  };

  let drag = null;
  let dragged = false;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-ll-size-guide-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog) return;
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'size_guide_open', product_handle: opener.dataset.productHandle });
      } catch (e) {}
      return;
    }

    const zoomBtn = event.target.closest('[data-ll-size-guide-zoom-btn]');
    if (zoomBtn) {
      const dialog = zoomBtn.closest('dialog');
      setZoom(dialog, !dialog.querySelector('[data-ll-size-guide-zoom]').classList.contains('is-zoomed'));
      return;
    }

    const zoom = event.target.closest('[data-ll-size-guide-zoom]');
    if (zoom) {
      if (dragged) {
        dragged = false;
        return;
      }
      setZoom(zoom.closest('dialog'), !zoom.classList.contains('is-zoomed'));
      return;
    }

    const closer = event.target.closest('[data-ll-size-guide-close]');
    if (closer) {
      closer.closest('dialog').close();
      return;
    }

    if (event.target.matches('dialog.ll-size-guide')) event.target.close();
  });

  // mouse drag to pan the zoomed chart (touch pans natively)
  document.addEventListener('pointerdown', (event) => {
    if (event.pointerType !== 'mouse') return;
    const scroll = event.target.closest('.ll-size-guide__scroll');
    if (!scroll || !scroll.querySelector('.is-zoomed')) return;
    drag = { scroll, x: event.clientX, y: event.clientY, left: scroll.scrollLeft, top: scroll.scrollTop };
    dragged = false;
  });
  document.addEventListener('pointermove', (event) => {
    if (!drag) return;
    const dx = event.clientX - drag.x;
    const dy = event.clientY - drag.y;
    if (!dragged && Math.abs(dx) + Math.abs(dy) < 4) return;
    dragged = true;
    drag.scroll.classList.add('is-dragging');
    drag.scroll.scrollLeft = drag.left - dx;
    drag.scroll.scrollTop = drag.top - dy;
  });
  document.addEventListener('dragstart', (event) => {
    if (event.target.closest && event.target.closest('.ll-size-guide__scroll')) event.preventDefault();
  });
  const endDrag = () => {
    if (!drag) return;
    drag.scroll.classList.remove('is-dragging');
    drag = null;
  };
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  // reset zoom whenever the dialog closes
  document.addEventListener(
    'close',
    (event) => {
      if (event.target.matches && event.target.matches('dialog.ll-size-guide')) setZoom(event.target, false);
    },
    true
  );
})();
